module.exports = __webpack_public_path__ + "img/ewm_1.24aa78ba.png";